import { render } from "./BaseFooterNav.vue?vue&type=template&id=636756f0&scoped=true"
import script from "./BaseFooterNav.vue?vue&type=script&lang=js"
export * from "./BaseFooterNav.vue?vue&type=script&lang=js"

import "./BaseFooterNav.vue?vue&type=style&index=0&id=636756f0&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636756f0"]])

export default __exports__